export enum PaymentDirectionEnum {
  AP = 'AP',
  AR = 'AR'
}
